var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#1A496D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 24H40.0267M40 40C48.8366 40 56 32.8366 56 24C56 15.1634 48.8366 8 40 8C31.1634 8 24 15.1634 24 24C24 24.7298 24.0489 25.4482 24.1435 26.1521C24.2991 27.3098 24.377 27.8887 24.3246 28.2549C24.27 28.6364 24.2005 28.842 24.0125 29.1784C23.832 29.5013 23.5139 29.8194 22.8777 30.4556L9.24968 44.0837C8.78847 44.5449 8.55787 44.7755 8.39296 45.0446C8.24675 45.2832 8.139 45.5433 8.07368 45.8154C8 46.1223 8 46.4484 8 47.1006V51.7333C8 53.2268 8 53.9735 8.29065 54.544C8.54631 55.0457 8.95426 55.4537 9.45603 55.7094C10.0265 56 10.7732 56 12.2667 56H16.8994C17.5516 56 17.8777 56 18.1846 55.9263C18.4567 55.861 18.7168 55.7533 18.9554 55.607C19.2245 55.4421 19.4551 55.2115 19.9163 54.7503L33.5444 41.1223C34.1806 40.4861 34.4987 40.168 34.8216 39.9875C35.158 39.7995 35.3636 39.73 35.7451 39.6754C36.1113 39.623 36.6902 39.7009 37.8479 39.8565C38.5518 39.9511 39.2702 40 40 40Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAccess);
export default __webpack_public_path__ + "static/media/status-access.55240d3645e4fd355ca8e8075a18f2c8.svg";
export { ForwardRef as ReactComponent };